const password2Helper = t => (password,password2) => {
  if (password === password2) return null;
  return t("auth.password_not_match");
}

export { password2Helper }
